import { ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import {
  CardColumn,
  FullHeightCard,
  ConfigCardContentWrapper,
  ConfigTitleGroup,
  HeaderIconBox,
  ConfigHeaderLabel,
  ConfigGrid,
  ConfigItem,
  ConfigItemHeader,
  MetricLabelText,
  ConfigValueText,
} from '../../styles';
import type { ConfigItemData } from '../../types';

interface ConfigCardProps {
  configItems: ConfigItemData[];
}

// Displays a summary of the traceroute configuration settings in a card format
export function ConfigCard({ configItems }: ConfigCardProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <CardColumn>
      <FullHeightCard>
        <ConfigCardContentWrapper>
          <ConfigTitleGroup>
            <HeaderIconBox>
              <ShieldCheck size={18} />
            </HeaderIconBox>
            <ConfigHeaderLabel variant="caption">
              {t('tools.traceroute.configSummary')}
            </ConfigHeaderLabel>
          </ConfigTitleGroup>
          <ConfigGrid>
            {configItems.map((item) => (
              <ConfigItem key={item.id}>
                <ConfigItemHeader>
                  <item.icon size={14} color={theme.palette.primary.main} />
                  <MetricLabelText>{item.label}</MetricLabelText>
                </ConfigItemHeader>
                <ConfigValueText variant="body1" title={item.value}>
                  {item.value}
                </ConfigValueText>
              </ConfigItem>
            ))}
          </ConfigGrid>
        </ConfigCardContentWrapper>
      </FullHeightCard>
    </CardColumn>
  );
}

export default ConfigCard;
